var journal = {
	data () {
		return {
			listJournals: [],
			objectJournal: {
				ItemId: 0,
				PostedPeriod: '',
				JournalDate: '',
				Description: '',
				Items: []
			},
			objectItemJournal: {
				ItemId: 0,
				AccountCode: '',
				SubAccountCode: '',
				FundCode: '10',
				FunctionCode: '',
				RestrictionCode: '',
				EntityValue: '',
				TypeEntityValue: 'D',
				Description: '',
				Memo: '',
				SendMemo: ''
			}
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		addNewObjectJournalItems(item) {
			this.objectJournal.Items.push({
				AccountCode: (item.AccountCode == null) ? '' : item.AccountCode,
				SubAccountCode: (item.SubAccountCode == null) ? '' : item.SubAccountCode,
				FundCode: (item.FundCode == null) ? '' : item.FundCode,
				FunctionCode: (item.FunctionCode == null) ? '' : item.FunctionCode,
				RestrictionCode: (item.RestrictionCode == null) ? '' : item.RestrictionCode,
				TypeEntityValue: (item.TypeEntityValue == null) ? 'D' : item.TypeEntityValue,
				EntityValue: (item.EntityValue == null) ? 0 : (item.TypeEntityValue == 'D') ? item.EntityValue : -1 * parseInt(item.EntityValue),
				Description: (item.Description == null) ? '' : item.Description,
				Memo: (item.Memo == null) ? '' : item.Memo,
				SendMemo: (item.Memo == null) ? '' : item.SendMemo,
			})
			return true
		},
		clearObjectJournal() {
			this.objectJournal.ItemId = 0
			this.objectJournal.PostedPeriod = ''
			this.objectJournal.JournalDate = ''
			this.objectJournal.Description = ''
			this.objectJournal.Items = []
			this.clearObjectItemJournal()
			return true
		},
		clearObjectItemJournal() {
			this.objectItemJournal.ItemId = 0
			this.objectItemJournal.AccountCode = ''
			this.objectItemJournal.AccountName = ''
			this.objectItemJournal.SubAccountCode = ''
			this.objectItemJournal.SubAccountName = ''
			this.objectItemJournal.FundCode = ''
			this.objectItemJournal.FundName = ''
			this.objectItemJournal.FunctionCode = ''
			this.objectItemJournal.FunctionName = ''
			this.objectItemJournal.RestrictionCode = ''
			this.objectItemJournal.RestrictionName = ''
			this.objectItemJournal.EntityValue = ''
			this.objectItemJournal.TypeEntityValue = 'D'
			this.objectItemJournal.Description = ''
			this.objectItemJournal.Memo = ''
			this.objectItemJournal.SendMemo = ''
			return true
		},
		deleteObjectJournalItems(index) {
			let objectJournalItems = this.objectJournal.Items.splice(index,1)			
		},
	},
};

export default journal;